/**
 * Accessible on/off switch used by the Automations cards and Customize panel. Pure presentational
 * control — the parent owns the enabled state and the PATCH /sub-agents/:id/config mutation.
 */
export function AutomationToggle({
  on,
  disabled,
  onToggle,
  label,
}: {
  on: boolean;
  disabled?: boolean;
  onToggle: () => void;
  /** Accessible label, e.g. "Turn Daily Brief on". */
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled}
      className={`auto-toggle${on ? " is-on" : ""}`}
      onClick={onToggle}
    >
      <span className="auto-toggle__track" aria-hidden="true">
        <span className="auto-toggle__knob" />
      </span>
    </button>
  );
}
